import {
  getTimbreDesignPageApi,
  mapTimbreDesignRowToVoiceToneItem,
} from "../../service/timbreDesign";
import {
  cartesian4,
  expandDimForRequest,
  itemMatchesMultiFilters,
  mergeVoiceListsUnique,
  softenDims,
} from "./publicVoiceMultiFetch";

const MINE_PAGE_SIZE = 500;

type MinePageBase = Omit<TimbreDesign.TimbreDesignPageQuery, "pageNo" | "pageSize">;

async function fetchMineVoiceAllPagesForParams(base: MinePageBase): Promise<VoicePublic.VoiceToneItem[]> {
  const out: VoicePublic.VoiceToneItem[] = [];
  let pageNo = 1;
  let total = 0;
  for (;;) {
    const res = await getTimbreDesignPageApi({
      ...base,
      pageNo,
      pageSize: MINE_PAGE_SIZE,
    });
    if (res.code !== 0 || !res.data?.list) break;
    total = Number(res.data.total) || 0;
    const chunk = res.data.list.map(mapTimbreDesignRowToVoiceToneItem);
    out.push(...chunk);
    if (chunk.length === 0 || out.length >= total || chunk.length < MINE_PAGE_SIZE) break;
    pageNo += 1;
  }
  return out;
}

/**
 * 「我的音色」列表：与公共音色类似，多选筛选时拆请求并在前端做 AND/OR 收敛。
 * 单组合内按 total 分页拉全。
 */
export async function fetchMineVoiceListMulti(
  debouncedVoiceName: string,
  langs: string[],
  genders: string[],
  ages: string[],
  timbres: string[]
): Promise<VoicePublic.VoiceToneItem[]> {
  const base: MinePageBase = {};
  if (debouncedVoiceName) base.voiceName = debouncedVoiceName;

  let L = expandDimForRequest(langs);
  let G = expandDimForRequest(genders);
  let A = expandDimForRequest(ages);
  let T = expandDimForRequest(timbres);
  [L, G, A, T] = softenDims(L, G, A, T);

  const combos = cartesian4(L, G, A, T);
  const requests: MinePageBase[] = combos.map(([l, g, a, t]) => {
    const p: MinePageBase = { ...base };
    if (l !== undefined) p.langCode = l;
    if (g !== undefined) p.genderValue = g;
    if (a !== undefined) p.ageValue = a;
    if (t !== undefined) p.timbreValue = t;
    return p;
  });

  const lists = await Promise.all(requests.map((p) => fetchMineVoiceAllPagesForParams(p)));
  let merged = mergeVoiceListsUnique(lists);
  merged = merged.filter((item) => itemMatchesMultiFilters(item, langs, genders, ages, timbres));
  return merged;
}
